let Constants = {
    API_PROMOCODE: "fiori-2025",
    CH_PROMO: "CH_1075_MLB_WEB_FIORIMULINO_NAV_NAV_20250828_20250914",
    PROMO_CODE: "1075"
}

export default Constants;